<template>
  <div
    class="pdp-empty-state-card mt-4"
  >
    <h4 class="pdp-empty-state-title pdp-section-title font-weight-bold h2">
      {{ title }}
    </h4>
    <div class="pdp-empty-state-description pdp-text">
      {{ description }}
    </div>
    <button
      v-if="!!buttonText"
      class="pdp-empty-state-btn btn btn-secondary mt-3"
      :disabled="buttonDisabled"
      @click="$emit('btn-clicked')"
    >
      {{ buttonText }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: false,
      default: undefined,
    },
    buttonDisabled: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../styles/abstracts/mixins';
  @import '~/styles/utils/breakpoints';

  .pdp-empty-state-card {
    @include pdp-card-style;

    padding: 28px;
  }

  .btn-secondary:disabled {
    @include pdp-disabled-btn;
  }

  // jw: we need to tweak the UI on viewports under the large size.
  @include media-breakpoint-down(md) {
    /* stylelint-disable selector-no-qualifying-type */
    div.pdp-empty-state-card {
      padding: 16px;

      .pdp-section-title {
        font-size: 20px;
        line-height: 30px;
        font-weight: 600;
      }

      .pdp-empty-state-btn {
        width: 100%;
        text-align: center;
      }
    }
  }
  /* stylelint-enable selector-no-qualifying-type */
</style>
